import { CertificateOfOccupancyType } from './CertificateOfOccupancyType';

export const CertificateOfOccupancyTypeOptions = [
    {
        id: CertificateOfOccupancyType.Yes,
        name: 'Yes, has a CO',
        shortName: 'Yes, has a CO',
        sortOrder: 1,
        active: true,
    },
    {
        id: CertificateOfOccupancyType.No,
        name: 'No',
        shortName: 'No',
        sortOrder: 4,
        active: true,
    },
    {
        id: CertificateOfOccupancyType.TCO,
        name: 'Sort of, has a TCO or similar',
        shortName: 'Sort of, has a TCO or similar',
        sortOrder: 3,
        active: true,
    },
    {
        id: CertificateOfOccupancyType.LocalEquivalent,
        name: 'Yes, has CO equivalent',
        shortName: 'Yes, has CO equivalent',
        sortOrder: 2,
        active: true,
    },
];
